<template>
    <div class="storeMess">
        <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-width="100px"
            class="storeMessForm"
        >
            <div class="storeMessTitle">
                <h4 class="storeMessTitleH">基本资料</h4>
            </div>
            <el-form-item label="头像：" prop="iconUrl">
                <div class="imgMess">
                    <img v-if="form.iconUrl == null" src="../../assets/users.png" alt=""/>
                    <img v-if="form.iconUrl != null" :src="form.iconUrl" alt=""/>
                    <!--<div class="imgUrl">
                        <p>请上传1M以下的图片，建议上传比例为1:1</p>
                        <uploadImage
                            :buttonName="'上传头像'"
                            @avatarChange="avatarChange($event)"
                            @getDragImgFile="getDragImgFile($event)"
                            @deleteImg="deleteImg($event)"
                            :imgListShow="false"
                            max-size="1m"
                        ></uploadImage>
                    </div>-->
                </div>
            </el-form-item>
            <el-form-item label="昵称：" prop="nickname">
                <p v-show="nameShow">
                    {{ form.nickname }}
                    <!--<i class="el-icon-edit iconBl" @click="nameShow = false"></i>-->
                </p>
                <div v-show="!nameShow">
                    <el-input v-model="form.nickname" style="width: 240px"></el-input>
                    <!--<i class="el-icon-check iconBl" @click="nameShow = true"></i>-->
                </div>
            </el-form-item>
            <el-form-item label="性别：" prop="sex">
                <el-radio-group v-model="form.sex">
                    <el-radio label="MALE">男</el-radio>
                    <el-radio label="FEMALE">女</el-radio>
                    <el-radio label="SECRET">保密</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="地区：" prop="district">
                <el-cascader
                    v-model="value"
                    :options="options"
                    @change="handleChange"
                    class="cascaderInput"
                ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
                <p v-show="addShow">
                    {{ form.address }}
                    <i class="el-icon-edit iconBl" @click="addShow = false"></i>
                </p>
                <div v-show="!addShow">
                    <el-input v-model="form.address" style="width: 400px"></el-input>
                    <i class="el-icon-check iconBl" @click="addShow = true"></i>
                </div>
                <!-- <el-input v-model="form.name"></el-input> -->
            </el-form-item>
            <el-form-item label="个人介绍：" prop="introduction">
                <el-input
                    type="textarea"
                    v-model="form.introduction"
                    maxlength="100"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <!--<el-form-item label="设计师认证：" prop="status">-->
                <!--<p style="cursor: pointer" v-if="form.status==='PASS'">{{ form.typeCn |ellipsis }}</p>-->
                <!--<p style="color: #3d7fff; cursor: pointer" v-else>去认证</p>-->
            <!--</el-form-item>-->
            <el-form-item label="联系电话：" prop="mobile">
                <p v-show="mobile">
                    {{ form.mobile }}
                    <!--<i class="el-icon-edit iconBl" @click="mobile = false"></i>-->
                </p>
                <div v-show="!mobile">
                    <el-input v-model="form.mobile" style="width: 200px"></el-input>
                    <!--<i class="el-icon-check iconBl" @click="mobile = true"></i>-->
                </div>
            </el-form-item>
            <el-form-item label="联系邮箱：" prop="email">
                <p v-show="emailShow">
                    {{ form.email }}
                    <i class="el-icon-edit iconBl" @click="emailShow = false"></i>
                </p>
                <div v-show="!emailShow">
                    <el-input v-model="form.email" style="width: 400px"></el-input>
                    <i class="el-icon-check iconBl" @click="emailShow = true"></i>
                </div>
                <!-- <el-input v-model="form.name"></el-input> -->
            </el-form-item>
            <el-form-item label="擅长领域：" required>
                <el-checkbox-group v-model="goodAtListValues">
                    <el-checkbox
                        v-for="item in goodAtThings"
                        :label="item.code"
                        :key="item.uuid"
                    >{{ item.name }}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Keywords：" prop="metaKeywords">
                <el-input
                    type="textarea"
                    v-model="form.metaKeywords"
                    maxlength="50"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item label="Description：" prop="metaDescription">
                <el-input
                    type="textarea"
                    v-model="form.metaDescription"
                    maxlength="70"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <div class="storeMessTitle storeMessTitleAdd">
                <h4 class="storeMessTitleH">工作经历</h4>
                <i class="el-icon-plus" @click="addTags('WORK')"></i>
            </div>
            <div
                v-for="(items, index) in workList"
                :key="index + '-only'"
                class="workListbox"
            >
                <p class="worksMinus" @click="delTags('WORK',index)" v-show="workList.length > 1">删除</p>
                <el-form-item label="公司名称：">
                    <el-input
                        v-model="items.companyName"
                        maxlength="25"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="在职时间：">
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="选择日期"
                            v-model="items.dutyTimeStart"
                            style="width: 100%"
                            @change="dutyTimeHandle(index,'start','work')"
                        ></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1" style="margin-left: 15px">-</el-col>
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="选择日期"
                            v-model="items.dutyTimeEnd"
                            style="width: 100%"
                            @change="dutyTimeHandle(index,'end','work')"
                        ></el-date-picker>
                    </el-col>
                </el-form-item>

                <el-form-item label="工作描述：">
                    <el-input type="textarea" v-model="items.workDesc"></el-input>
                </el-form-item>
            </div>

            <div class="storeMessTitle storeMessTitleAdd require-tag">
                <h4 class="storeMessTitleH">教育经历</h4>
                <i class="el-icon-plus" @click="addTags('EDU')"></i>
            </div>
            <div
                v-for="(items, index) in eduList"
                :key="index + '-only2'"
                class="workListbox"
            >
                <p class="worksMinus" @click="delTags('EDU',index)" v-show="eduList.length > 1">删除</p>
                <el-form-item label="学校名称：" required>
                    <el-input
                        v-model="items.schoolName"
                        maxlength="25"
                        show-word-limit
                    ></el-input>
                </el-form-item>
                <el-form-item label="在校时间：" required>
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="选择日期"
                            v-model="items.schoolTimeStart"
                            style="width: 100%"
                            @change="dutyTimeHandle(index,'start','school')"
                        ></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1" style="margin-left: 15px">-</el-col>
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="选择日期"
                            v-model="items.schoolTimeEnd"
                            style="width: 100%"
                            @change="dutyTimeHandle(index,'end','school')"
                        ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="专业：" required>
                    <el-input
                        v-model="items.major"
                        maxlength="25"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </div>

            <div class="storeMessTitle storeMessTitleAdd">
                <h4 class="storeMessTitleH">获奖经历</h4>
                <i class="el-icon-plus" @click="addTags('AWARD')"></i>
            </div>
            <div
                v-for="(items, index) in awardList"
                :key="index + '-only3'"
                class="workListbox"
            >
                <p class="worksMinus" @click="delTags('AWARD',index)" v-show="awardList.length > 1">删除</p>

                <el-form-item label="获奖时间：">
                    <el-col :span="11">
                        <el-date-picker
                            type="date"
                            placeholder="选择日期"
                            v-model="items.awardTime"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="获奖名称：">
                    <el-input
                        v-model="items.awardName"
                        maxlength="25"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </div>

            <el-form-item>
                <el-button type="primary" @click="validateFrom()">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import uploadImage from "../../components/uploadImage/index";
import {designerByUserId, getDictionaryItem, updateDesigner, getNewcurrent} from "../../utils/interface";
import provinceData from "../../utils/provinceData";
export default {
    components: {
        uploadImage,
    },
    data() {
        return {
            formOrg: {},
            form: {
                name: "",
                sex: "",
                sexCn: "",
                addressDei: "",
                introduce: "",
                mobile: "",
                email: "",
                type: [],
                companyName: "",
                date1: "",
                date2: "",
                workDesc: "",
                schoolName: "",
                schoolTimeStart: "",
                schoolTimeEnd: "",
                major: "",
                awardTime: "",
                awardName: "",
                imageUrl: "",
                iconUrl: ""
            },
            goodAtThings: [],
            nameShow: true,
            mobile: true,
            addShow: true,
            emailShow: true,
            imgListurl: "",
            // 地区选择
            value: [],
            options: provinceData,
            // 表单校验
            rules: {
                // iconUrl: [
                //     {required: true, message: "请上传头像", trigger: "change"}
                // ],
                // nickname: [
                //     {required: true, message: "请填写昵称", trigger: "change"}
                // ],
                sex: [
                    {required: true, message: "请选择性别", trigger: "change"},
                ],
                address: [
                    {required: true, message: "请填写详细地址", trigger: "change"},
                ],
                introduction: [
                    {required: true, message: "请填写个人介绍", trigger: "change"},
                ],
                // mobile: [
                //     {required: true, message: "请填写联系电话", trigger: "change"},
                // ],
                email: [
                    {required: true, message: "请填写邮箱", trigger: "change"}
                ],
                status: [
                    {required: true, message: "请填写认证信息", trigger: "change"},
                ],
                goodAtListValues: [
                    { type: "array", required: true, message: "请选择擅长领域", trigger: "change"},
                ],
                metaKeywords:[
                    {max: 50, message: '最多允许输入50个汉字'}
                ],
                metaDescription:[
                    {max: 70, message: '最多允许输入70个汉字'}
                ]
            },
            // 擅长领域
            goodAtListValues: [],
            // 工作经历
            workList: [],
            // 教育经历
            eduList: [],
            // 获奖经历
            awardList: [],
            dutyTimeStartString: '',
            dutyTimeEndString: '',
            schoolTimeStartString: '',
            schoolTimeEndString: '',
            userMessages: {},
        };
    },
    created() {
        // 查询擅长领域
        getDictionaryItem({groupCode: 'DESIGNER_GOODAT'}).then(x => {
            console.log(x)
            this.goodAtThings = x
        })
        getNewcurrent()
            .then((res) => {
                this.userMessages = res;
                // 查询设计师信息
                designerByUserId(this.userMessages.uuid).then((res) => {
                    console.log(res);
                    if (res.city === res.district) {
                        this.value = [res.province, res.city];
                    } else {
                        this.value = [res.province, res.city, res.district];
                    }
                    this.workList = []
                    this.eduList = []
                    this.awardList = []
                    this.goodAtListValues = res.designerGoodatList.map(x => x.goodatUuid);
                    if (res.designerDetailList && res.designerDetailList.length > 0)
                        res.designerDetailList.forEach(x => {
                            if (x.detailType === 'WORK') {               //工作经历
                                let t = (x.dutyTime || "-").split(/-/);
                                this.workList.push({
                                    uuid: x.uuid,
                                    companyName: x.companyName,
                                    workDesc: x.workDesc,
                                    dutyTimeStart: t[0],
                                    dutyTimeEnd: t[1]
                                })
                            } else if (x.detailType === "EDU") {         //教育经历
                                let t = (x.schoolTime || "-").split(/-/);
                                this.eduList.push({
                                    uuid: x.uuid,
                                    schoolName: x.schoolName,
                                    major: x.major,
                                    schoolTimeStart: t[0],
                                    schoolTimeEnd: t[1]
                                })
                            } else if (x.detailType === "AWARD") {       //获奖经历
                                this.awardList.push({
                                    uuid: x.uuid,
                                    awardTime: x.awardTime,
                                    awardName: x.awardName
                                })
                            }
                        })
                    this.formOrg = JSON.parse(JSON.stringify(res));
                    this.form = res;
                });
            })
            .catch((err) => {
                console.log(err);
            });
    },
        filters: {
            ellipsis(value) {
                return value.replace("|", '和');
            }
        },
    methods: {
        // 地区选择
        handleChange(value) {
            if (value != null && value.length === 3) {
                this.form.province = value[0]
                this.form.city = value[1]
                this.form.district = value[2]
            } else if (value != null && value.length === 2) {
                this.form.province = value[0]
                this.form.city = value[1]
                this.form.district = value[1]
            }
        },
        validateFrom() {
            if (this.goodAtListValues.length===0) {
                this.$message.error("至少选择一个擅长领域")
                return false
            }
            if (this.eduList.length===0) {
                this.$message.error("请填写教育经历")
                return false
            }
            let eduOK = true
            this.eduList.forEach(x=>{
                if (x.schoolName && x.schoolTimeStart && x.schoolTimeEnd && x.major){
                }else{
                    eduOK = false
                }
            })
            if (!eduOK) {
                this.$message.error("请填写教育经历中的项目")
                return false
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.onSubmit()
                } else {
                    this.$message.error("请按要求输入内容");
                    return false;
                }
            })
        },

        onSubmit() {
            let {
                uuid,
                iconUrl,
                province,
                city,
                district,
                address,
                nickname,
                sex,
                introduction,
                mobile,
                email,
                frontIdentityUrl,
                backIdentityUrl,
                identityNo,
                name
            } = this.form

            let goodAtList = []
            this.goodAtListValues.forEach(x => {
                if (!x) return;
                let goodAt = this.goodAtThings.find(t => (t.code === x))
                console.log(goodAt)
                goodAtList.push({
                    designerUuid: uuid,
                    goodatName: goodAt.name,
                    goodatUuid: x
                })
            })
            let params = {
                uuid,
                iconUrl,
                province,
                city,
                district,
                address,
                nickname,
                sex,
                introduction,
                mobile,
                email,
                frontIdentityUrl,
                backIdentityUrl,
                identityNo,
                name
            }
            if (goodAtList && goodAtList.length > 0) params.designerGoodatList = goodAtList
            let designerDetailList = []
            let designerUuid = this.form.uuid
            if (this.workList.length > 0) {
                designerDetailList = designerDetailList.concat(this.workList.map(x => {
                    let {companyName, workDesc} = x
                    let dutyTime = `${this.$common.formatDate(x.dutyTimeStart)}-${this.$common.formatDate(x.dutyTimeEnd)}`
                    return {detailType: "WORK", designerUuid, companyName, workDesc, dutyTime}
                }))
            }
            if (this.eduList.length > 0) {
                designerDetailList = designerDetailList.concat(this.eduList.map(x => {
                    let {schoolName, major} = x
                    let schoolTime = `${this.$common.formatDate(x.schoolTimeStart)}-${this.$common.formatDate(x.schoolTimeEnd)}`
                    return {detailType: "EDU", designerUuid, schoolName, major, schoolTime}
                }))
            }
            if (this.awardList.length > 0) {
                designerDetailList = designerDetailList.concat(this.awardList.map(x => {
                    let {awardName} = x
                    let awardTime = this.$common.formatDate(x.awardTime)
                    return {detailType: "AWARD", designerUuid, awardName, awardTime}
                }))
            }
            console.log(this.workList, this.eduList, this.awardList, designerDetailList)
            if (designerDetailList.length > 0) params.designerDetailList = designerDetailList

            updateDesigner(params).then(res => {
                if (res.success) {
                    this.$message({message: res.message, type: "success"})
                } else {
                    this.$message({message: res.message, type: "error"})
                }
                console.log(res)
            })
        },
        // 图片上传
        // 上传成功
        avatarChange(val) {
            this.form.iconUrl = val[0].url;
        },
        // 获取拖拽后的图片
        getDragImgFile(file) {
            if (file) {
                this.form.iconUrl = file[0].url;
            }
        },
        // 删除图片
        deleteImg(val) {
            this.form.imgList = val;
        },
        // 添加内容
        addTags(tag) {
            if (tag === "WORK") {
                this.workList.push({
                    designerUuid: this.form.uuid,
                    detailType: "WORK",
                    companyName: "",
                    dutyTimeStart: "",
                    dutyTimeEnd: "",
                    workDesc: "",
                });
            } else if (tag === "EDU") {
                this.eduList.push({
                    designerUuid: this.form.uuid,
                    detailType: "EDU",
                    schoolName: "",
                    schoolTimeStart: "",
                    schoolTimeEnd: "",
                    major: "",
                });
            } else if (tag === "AWARD") {
                this.awardList.push({
                    designerUuid: this.form.uuid,
                    detailType: "AWARD",
                    awardTime: "",
                    awardName: "",
                });
            }
        },
        // 删除
        delTags(tag, index) {
            if (tag === 'WORK') {
                this.workList.splice(index, 1)
            } else if (tag === 'EDU') {
                this.eduList.splice(index, 1)
            } else if (tag === 'AWARD') {
                this.awardList.splice(index, 1)
            }
        },
        // 转换时间
        getDate(date) {
            let year = date.getFullYear().toString()
            let month = (date.getMonth() + 1).toString()
            let day = date.getDate().toString()

            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            return year + month + day
        },
        dutyTimeHandle(index, type, mess) {
            if (mess == 'work') {
                // work
                let startDate = this.workList[index].dutyTimeStart
                let endDate = this.workList[index].dutyTimeEnd
                if (type == 'start') {
                    if (startDate) {
                        this.dutyTimeStartString = this.getDate(startDate)
                    }

                } else if (type == 'end') {
                    if (endDate) {
                        this.dutyTimeEndString = this.getDate(endDate)
                    }

                }
                console.log('666', this.dutyTimeStartString > this.dutyTimeEndString);

                if (this.dutyTimeStartString != '' && this.dutyTimeEndString != '') {
                    if (this.dutyTimeStartString > this.dutyTimeEndString) {
                        console.log('在职时间开始时间不能大于结束时间',);
                        this.workList[index].dutyTimeEnd = ''
                        this.$alert('在职时间开始时间不能大于结束时间?', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        })
                    }
                }
            } else if (mess == 'school') {
                // school
                let startDateSchool = this.eduList[index].schoolTimeStart
                let endDateSchool = this.eduList[index].schoolTimeEnd
                if (type == 'start') {
                    if (startDateSchool) {
                        this.schoolTimeStartString = this.getDate(startDateSchool)
                    }

                } else if (type == 'end') {
                    if (endDateSchool) {
                        this.schoolTimeEndString = this.getDate(endDateSchool)
                    }

                }
                if (this.schoolTimeStartString != '' && this.schoolTimeEndString != '') {
                    if (this.schoolTimeStartString > this.schoolTimeEndString) {
                        console.log('在校时间开始时间不能大于结束时间',);
                        this.eduList[index].schoolTimeEnd = ''
                        this.$alert('在校时间开始时间不能大于结束时间?', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        })
                    }
                }
            }

        },
        changeGoodAt(e) {
            console.log(e)
            this.form.goodAt = e.length > 0 ? "1" : "";
        }
    },
};
</script>

<style scoped lang="less">
p {
    margin: 0;
}

.storeMess {
    .storeMessForm {
        width: 50%;
        margin: 0 auto;

        .storeMessTitle {
            margin: 20px 0;
            border-bottom: 1px solid #efefef;

            .storeMessTitleH {
                border-bottom: 3px solid #3d7fff;
                color: #3d7fff;
                width: 68px;
                padding-bottom: 5px;
                margin: 0;
            }
        }

        .storeMessTitleAdd {
            display: flex;
            justify-content: space-between;

            i {
                font-weight: bold;
                color: #3d7fff;
                margin-top: 5px;
                cursor: pointer;
            }
        }

        .workListbox {
            .worksMinus {
                display: inline-block;
                text-align: right;
                width: 100%;
                font-weight: bold;
                color: #3d7fff;
                cursor: pointer;
                margin-bottom: 5px;
            }

            // border-bottom: 1px solid #efefef;
            // margin-bottom: 20px;
        }
    }

    .iconBl {
        margin-left: 10px;
        color: #3d7fff;
        cursor: pointer;
    }

    .imgMess {
        display: flex;

        img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            margin-right: 20px;
        }

        .imgUrl {
            p {
                margin-bottom: 20px;
                font-size: 14px;
                color: #777777;
            }
        }
    }

    /deep/ .el-form-item__label {
        width: 120px !important;
    }

    /deep/ .el-form-item__content {
        margin-left: 120px !important;
    }
}

.dutyhelloColor {
    color: rgb(142, 0, 0);
    font-size: 14px;
}

.require-tag {
    position: relative;
}

.require-tag:before {
    content: '*';
    display: flex;
    align-items: center;
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeMessage.vue